import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevelopmentAPI} from "pages/workspace/process/development/development.service";

const initialState = {
  data: null,
  state: ""
};

// ✅ Define getTicketTabCount before using it in extraReducers
export const getTicketTabCount = createAsyncThunk(
  "ticketTabCount/get",
  async({ workspaceId, ticketId }) => {
    let data = await DevelopmentAPI.getIssuesCounts(workspaceId, ticketId);
    return data["issue"];
  }
);

export const ticketCountSlice = createSlice({
  name: "ticketTabCount",
  initialState,
  reducers: {
    // ✅ Reset state to initial values
    resetState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketTabCount.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getTicketTabCount.pending, (state) => {
        state.state = "pending";
      });
  }
});

export const { resetState } = ticketCountSlice.actions;
export default ticketCountSlice.reducer;
